<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="rtProcessTypes"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="类型编号">
            <el-input v-model.trim="filter.processTypeNo" placeholder="请输入类型编号" clearable/>
          </el-form-item>
          <el-form-item label="类型名称">
            <el-input v-model.trim="filter.processTypeName" placeholder="请输入类型名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <process-type-edit ref="processTypeEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ProcessTypeEdit from "./ProcessTypeEdit";
  export default {
    components: { viewTable, ProcessTypeEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(713),
          editAuth: this.$auth(714),
          delAuth: this.$auth(715),
        },
        filter: {
          processTypeNo: "",
          processTypeName: "",
        },
        columnsProperty: [
          {
            key: "processTypeNo",
            width: 140,
          },
          {
            key: "factoryName",
            minWidth: 150,
          },
          {
            key: "creatorName",
            width: 120,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.processTypeEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "rtProcessTypes", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
